import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { mockData } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-gray-300 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_azur-privee/artifacts/fnfsgk7v_AD29DC73-4E1D-4303-A0B4-6D865E1F5318.png" 
              alt="AzurDriver Pro" 
              className="h-12 w-auto"
            />
            <p className="text-sm text-gray-400">
              {mockData.company.slogan}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-amber-500 transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm hover:text-amber-500 transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/tarifs" className="text-sm hover:text-amber-500 transition-colors">
                  Tarifs
                </Link>
              </li>
              <li>
                <Link to="/a-propos" className="text-sm hover:text-amber-500 transition-colors">
                  À Propos
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-amber-500 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Nos Services</h3>
            <ul className="space-y-2">
              <li className="text-sm">Transferts Aéroport</li>
              <li className="text-sm">Transport Business</li>
              <li className="text-sm">Mise à Disposition</li>
              <li className="text-sm">Tourisme & Événements</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-sm">
                <Phone className="w-4 h-4 mt-0.5 text-amber-500 flex-shrink-0" />
                <span>{mockData.company.phone}</span>
              </li>
              <li className="flex items-start space-x-2 text-sm">
                <Mail className="w-4 h-4 mt-0.5 text-amber-500 flex-shrink-0" />
                <span>{mockData.company.email}</span>
              </li>
              <li className="flex items-start space-x-2 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 text-amber-500 flex-shrink-0" />
                <span>Nice, Côte d'Azur</span>
              </li>
              <li className="flex items-start space-x-2 text-sm">
                <Clock className="w-4 h-4 mt-0.5 text-amber-500 flex-shrink-0" />
                <span>{mockData.company.availability}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-slate-800 text-center">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} AzurDriver Pro. Tous droits réservés.
          </p>
          <p className="text-xs text-gray-500 mt-2">
            Chauffeur privé VTC Nice • Monaco • Cannes • Côte d'Azur
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
